<template>
  <div class="animated fadeIn">
    <Forms ref="frmCampanhaRedeSocil"
      :title="'CADASTRO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome da campanha'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName"><small class="text-danger">*</small> Origem do Lead:</label>
          <div class="input-group">
            <b-form-select v-model="form.origemId.value" :options="form.origemId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName"><small v-show="form.ativo.required" class="text-danger">*</small>A campanha está ativa?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.ativo.value" value="true" unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtName"><small v-if="form.nome.required" class="text-danger">*</small> Quadro</label>
          <div class="input-group">
            <b-form-select v-model="form.boardId.value" :options="form.boardId.options" @change="onChangeBoard">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>

        </div>
        <div class="col-md-4">
          <label for="txtName"><small v-if="form.nome.required" class="text-danger">*</small> Coluna:</label>
          <div class="input-group">
            <b-form-select v-model="form.boardColumnId.value" :options="form.boardColumnId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
          <div>

          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName">URL Redirecionamento:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-external-link-square-alt"></i></span>
            <b-form-input
              type="text"
              :placeholder="'https://minhacampanha.com/visualizar'"
              v-model="form.urlRedirecionamento.value"
              :required="form.urlRedirecionamento.required"
              :state="form.urlRedirecionamento.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtName">URL Conversão:</label>
          <div class="input-group" @click.prevent="onCopyUrlSocialMediaReturn" style="cursor: copy;">
            <span class="input-group-addon"><i class="fas fa-clone" v-b-tooltip.hover title="Clique para copiar"></i></span>
            <b-form-input
              type="text"
              class="text-third text-bold"
              :placeholder="'Copie e cole essa url para enviar os dados da sua campanha!'"
              v-model="form.urlConversao.value"
              :required="form.urlConversao.required"
              :state="form.urlConversao.state"
              :disabled="form.urlConversao.disabled"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName">URL para Webhook <small>(RD Station)</small>:</label>
          <div class="input-group" @click.prevent="onCopyUrlSocialMediaWebhook" style="cursor: copy;">
            <span class="input-group-addon"><i class="fas fa-clone" v-b-tooltip.hover title="Clique para copiar"></i></span>
            <b-form-input
              type="text"
              class="text-third text-bold"
              :placeholder="'Copie e cole essa url para enviar os dados da sua campanha!'"
              v-model="form.urlRdStation.value"
              :required="form.urlRdStation.required"
              :state="form.urlRdStation.state"
              :disabled="form.urlRdStation.disabled"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtName">Veja abaixo os campos necessário para envio (Conversão):</label>
          <div><small>Método de envio: <strong>POST</strong></small></div>
          <div data-v-0c5d892c="" style="border: solid 1px #ccc;border-radius: 4px;padding: 10px; width: 100%; background-color: #505050;color: #fff;">
            {<br>
              &nbsp;&nbsp;&nbsp;  nome: 'String',<br>
              &nbsp;&nbsp;&nbsp;  document: 'Number', <small>// CPF ou CNPJ</small> <br>
              &nbsp;&nbsp;&nbsp;  celular: 'String',<br>
              &nbsp;&nbsp;&nbsp;  email: 'String',<br>
              &nbsp;&nbsp;&nbsp;  utmSource: 'String',<br>
              &nbsp;&nbsp;&nbsp;  utmCampaign: 'String',<br>
              &nbsp;&nbsp;&nbsp;  utmMedium: 'String',<br>
              &nbsp;&nbsp;&nbsp;  utmContent: 'String',<br>
              &nbsp;&nbsp;&nbsp;  utmTerm: 'String',<br>
            }
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName">Veja abaixo os campos que serão recebidos via <strong>Webhook da RD Station</strong>:</label>
          <div><small>Método de envio: <strong>POST</strong></small></div>
          <div data-v-0c5d892c="" style="border: solid 1px #ccc;border-radius: 4px;padding: 10px; width: 100%; background-color: #505050;color: #fff; max-height: 235px; overflow: auto;">
            {<br>
              &nbsp;&nbsp;"leads":[<br>
              &nbsp;&nbsp;&nbsp;&nbsp;{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id":&nbsp;"1"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"email":&nbsp;"teste@rd.com.br"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"name":&nbsp;"Bruno&nbsp;do Santos"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"company":&nbsp;"Resultados&nbsp;Digitais"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"job_title":&nbsp;"IT"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"bio":&nbsp;"This&nbsp;is&nbsp;my&nbsp;bio"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"public_url":&nbsp;"http://rdstation.com.br/leads/public/e8d64a22-17a8-40e3-bb8c-c16af1861708"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at":&nbsp;"2012-06-04T15:31:35-03:00"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"opportunity":&nbsp;"false"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"number_conversions":&nbsp;"3"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"user":&nbsp;"email@example.com"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"first_conversion":{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content":{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"identificador":&nbsp;"ebook-abc"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"nome":&nbsp;"Bruno"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"email_lead":&nbsp;"suporte@resultadosdigitais.com.br"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"telefone":&nbsp;"99999999"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"empresa":&nbsp;"Resultados&nbsp;Digitais"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"cargo":&nbsp;"IT"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at":&nbsp;"2012-06-04T15:31:35-03:00"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"cumulative_sum":&nbsp;"1"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"source":&nbsp;"source&nbsp;1"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"last_conversion":&nbsp;{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content":&nbsp;{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"nome":&nbsp;"UAI&nbsp;TECNOLOGIA"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"telefone":&nbsp;"33227922"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"cep":&nbsp;"38066100"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Endereço":&nbsp;"UAI&nbsp;TECNOLOGIA"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"state_id":&nbsp;"27"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"city":&nbsp;"UBERABA"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"bairro":&nbsp;"UAI&nbsp;TECNOLOGIA"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mensagem":&nbsp;"Olá<br>&nbsp;\r\nPor&nbsp;favor<br>&nbsp;gostaríamos&nbsp;de&nbsp;apresentar&nbsp;nossa&nbsp;empresa&nbsp;brevemente..."<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"identificador":&nbsp;"webinar-abc"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"traffic_source":&nbsp;""<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"email_lead":&nbsp;"lgvg10@gmail.com"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"cidade":&nbsp;"Uberaba"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"estado":&nbsp;"MG"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at":&nbsp;"2012-06-04T15:31:35-03:00"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"cumulative_sum":&nbsp;"2"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"source":&nbsp;"source&nbsp;2"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"custom_fields":&nbsp;{<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CEP":&nbsp;"95680000"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"website":&nbsp;"http://www.resultadosdigitais.com.br"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"personal_phone":&nbsp;"48&nbsp;30252598"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mobile_phone":&nbsp;"48&nbsp;30252598"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"city":&nbsp;"Florianópolis"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"state":&nbsp;"SC"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"fit_score":&nbsp;"d"<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"interest":&nbsp;0<br>
              &nbsp;&nbsp;&nbsp;&nbsp;}<br>
              &nbsp;&nbsp;]<br>
              }
          </div>
        </div>
      </div>
      <input type="hidden" ref="myCopy" id="myCopy" name="myCopy" value="" />
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label > Campos Personalizados:</label>
          <i class="fa fa-info-circle" data-toggle="tooltip" data-placement="right" title="Ex de tags: maca, acai, melao... "></i>
          <b-form-group :state="state">
            <b-form-tags
              input-id="tags-validation"
              v-model="form.camposPersonalizados.value"
              placeholder="Digite as tags..."
              :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
              :tag-validator="tagValidator"
              :state="state"
              separator=" ">
            </b-form-tags>

      <template #invalid-feedback>
        Os nomes dos campos devem ser separados por vírgula, e não devem conter caracteres especiais. Ex: carro, marca, modelo
      </template>

      <template #description>
        <div id="tags-validation-help">
          Os nomes dos campos devem ser separados e minúsculas, e não devem conter caracteres especiais. Ex: $#%*&
        </div>
      </template>
    </b-form-group>
        </div>
  </div>

    </Forms>
  </div>
</template>
<script>
/* https://github.com/hinesboy/mavonEditor/blob/master/README-EN.md */
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'
import CampanhaRedeSocialRepository from '@/shared/http/repositories/configurations/socialmedia.js'
import CampanhaRedeSocialModel from '@/shared/models/configurations/campanharedesocialmodel.js'
import CampanhaRedeSocialForms from './campanharedesocialadd-form.js'

export default {
  name: 'CampanhaRedeSocialAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: CampanhaRedeSocialModel,
      form: CampanhaRedeSocialForms,
      toolbars: {
        bold: false,
        italic: false,
        header: false,
        underline: false,
        strikethrough: false,
        mark: false,
        superscript: false,
        subscript: false,
        quote: false,
        ol: false,
        ul: false,
        link: false,
        imagelink: false,
        code: false,
        table: false,
        fullscreen: false,
        readmodel: false,
        htmlcode: false,
        help: false,
        undo: false,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: false
      },
      customToolbar: {
        bold: {
          name: 'Negrito',
          icon: 'fa-mavon-bold text-third',
          prefix: '<b>',
          subfix: '</b>',
          str: ''
        },
        italic: {
          name: 'Itálico',
          icon: 'fa-mavon-italic text-third',
          prefix: '<i>',
          subfix: '</i>',
          str: ''
        },
        header: {
          name: 'Cabeçalho',
          icon: 'fa-mavon-header text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Cabeçalho 1',
              prefix: '<h1>',
              subfix: '</h1>',
              str: ''
            },
            {
              name: 'Cabeçalho 2',
              prefix: '<h2>',
              subfix: '</h2>',
              str: ''
            },
            {
              name: 'Cabeçalho 3',
              prefix: '<h3>',
              subfix: '</h3>',
              str: ''
            },
            {
              name: 'Cabeçalho 4',
              prefix: '<h4>',
              subfix: '</h4>',
              str: ''
            },
            {
              name: 'Cabeçalho 5',
              prefix: '<h5>',
              subfix: '</h5>',
              str: ''
            },
            {
              name: 'Cabeçalho 6',
              prefix: '<h6>',
              subfix: '</h6>',
              str: ''
            }
          ]
        },
        underline: {
          name: 'Sublinhar',
          icon: 'fa-mavon-underline text-third',
          prefix: '<ins>',
          subfix: '</ins>',
          str: ''
        },
        strikethrough: {
          name: 'Tachar',
          icon: 'fa-mavon-strikethrough text-third',
          prefix: '<del>',
          subfix: '</del>',
          str: ''
        },
        variables: {
          name: 'Variáveis',
          icon: 'fa-address-card text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Nome',
              prefix: '@',
              subfix: '@',
              str: 'Nome'
            },
            {
              name: 'Email',
              prefix: '@',
              subfix: '@',
              str: 'Email'
            },
            {
              name: 'Telefone',
              prefix: '@',
              subfix: '@',
              str: 'Telefone'
            },
            {
              name: 'Link de Conversão',
              prefix: '@',
              subfix: '@',
              str: 'CTA'
            }
          ]
        },
        undo: {
          name: 'Desfazer (CTRL+Z)',
          icon: 'fa-mavon-undo text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        redo: {
          name: 'Resfazer (CTRL+Y)',
          icon: 'fa-mavon-repeat text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        trash: {
          name: 'Limpar (CTRL+BREAKSPACE)',
          icon: 'fa-trash-alt text-third',
          prefix: '',
          subfix: '',
          str: ''
        }
      }
    }
  },
  watch: {
    'form.boardId.value': function (value) {
      if (value) {
        if (this.form.boardColumnId.options.length > 0) {
          this.form.boardColumnId.options = []
          this.form.boardColumnId.value = null
        }
        this.onChangeBoard(value)
      } else {
        this.form.boardColumnId.options = []
        this.form.boardColumnId.value = null
      }
    }
  },
  methods: {
    mouseLeaveDropdown (option) {
      option.timer = setTimeout(function () {
        option.dropdownOpen = false
      }, 200)
    },
    mouseEnterDropdown (option) {
      clearTimeout(option.timer)
      option.dropdownOpen = true
    },
    insertText (options) {
      const textArea = this.$refs.refMavonEditor.getTextareaDom()

      this.$refs.refMavonEditor.insertText(textArea, options)

      this.$nextTick(() => {
        let selection = options.subfix.length + textArea.selectionEnd

        textArea.selectionStart = selection
        textArea.selectionEnd = selection

        textArea.focus()
      })
    },
    onLoad () {
      this.onLoadAllBoards()
      this.onLoadAllOrigem()
    },
    onLoadAllOrigem () {
      OriginRepository.GetAll()
        .then((response) => {
          this.form.origemId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onLoadAllBoards () {
      BoardRepository.GetAll()
        .then((response) => {
          this.form.boardId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onChangeBoard (boardId) {
      BoardColumnRepository.SearchActive(boardId, 20, 0)
        .then((response) => {
          this.form.boardColumnId.options = this.onResultDropdown(response, null, f => f.nome.toUpperCase())
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.boardColumnId && obj.boardId) {
          this.form.boardId.value = obj.boardId
          this.$nextTick(() => {
            this.form.boardColumnId.value = obj.boardColumnId
          })
        }
        this.form.origemId.value = obj.origemId
        this.form.urlRdStation.value = obj.urlRdStation
        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      CampanhaRedeSocialRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      CampanhaRedeSocialRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onAddingOptionTextArea (value) {
      this.form.template.value = this.form.template.value + value + ' '
      this.$refs.templateText.focus()
      return false
    },
    onCopyUrlSocialMediaReturn () {
      if (this.data.urlConversao) {
        this.onCopy(this.data.urlConversao)
      }
    },
    onCopyUrlSocialMediaWebhook () {
      if (this.data.urlRdStation) {
        this.onCopy(this.data.urlRdStation)
      }
    },
    onCopy (value) {
      if (value) {
        var obj = this.$refs.myCopy
        obj.value = value
        obj.setAttribute('type', 'text')
        obj.select()
        document.execCommand('copy')
        toast.success(this.$lang.Common.Alerts.CopySuccess)
        obj.setAttribute('type', 'hidden')
      }
    },
    tagValidator (tag) {
      return tag === tag.toLowerCase()
        .replace(/[^a-zA-Z0-9áàâãéèêíìîóòôõúùûç,]+/g, ' ')
        .replace(/[áàâã]/g, 'a')
        .replace(/[éèê]/g, 'e')
        .replace(/[íìî]/g, 'i')
        .replace(/[óòôõ]/g, 'o')
        .replace(/[úùû]/g, 'u')
        .replace(/ç/g, 'c')
    }
  }
}
</script>

<style scoped>
.mavonEditor {
  border: solid 1px #ccc;
  min-width: 100%;
  min-height: 543px;
  max-height: 543px;
  overflow: scroll;
}
.v-note-wrapper.shadow {
  border: solid 1px #ccc;
}
.markdown-body>:first-child {
  background-color: #eceff1 !important;
  border-bottom: solid 1px #cfd8dc;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon,
.v-note-wrapper .v-note-op .v-right-item .op-icon {
  color: #006a5b !important;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon.selected,
.v-note-wrapper .v-note-op .v-right-item .op-icon.selected {
  color: #006a5b !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon:hover,
.v-note-wrapper .v-note-op .v-right-item .op-icon:hover {
  color: #005c50 !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon button, .v-note-wrapper .v-note-op .v-right-item .op-icon button {
  color: #006a5b;
}
button.op-icon {
  color: #006a5b !important;
}
.nxbr-toolbar {
  background-color: #eceff1 !important;
  border-top: solid 1px #cfd8dc;
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/campaign/components/socialmedia/components/add/campanharedesocialadd.vue